import { FC, useEffect, useState } from 'react'
import { Link } from 'react-router'
import r from 'routes'

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Card, CardContent, CardFooter } from '@/components/ui/card'
import { Branding } from '@/out/branding'

type Props = {
  branding: Branding
  onRefresh: () => void
}

const ActiveDomainCard: FC<Props> = ({ branding, onRefresh }) => {
  const [countdown, setCountdown] = useState(10)
  useEffect(() => {
    if (!branding.domain || branding.domainIsVerified) return

    const t = setInterval(() => {
      setCountdown(prev => {
        if (prev === 1) {
          onRefresh()
          return 10
        }
        return prev - 1
      })
    }, 1_000)

    return () => clearInterval(t)
  }, [branding, onRefresh])

  return (
    <Card>
      <CardContent className="grid gap-8 pt-6">
        <div className="space-y-4">
          {branding.domainIsVerified ? (
            <div>
              <Alert className="text-green-600 border-green-100 bg-green-50/80">
                <AlertTitle className="flex items-center gap-2">
                  <div className="bg-green-500 rounded-full w-2.5 h-2.5 animate-pulse" />
                  <span className="font-mono">{branding.domain}</span>
                  <span className="text-green-600/75">is verified and active</span>
                </AlertTitle>
                <AlertDescription className="mt-2">
                  Your domain will now appear in the links sent to your customers via SMS as well as in your
                  customers&apos; browser.
                </AlertDescription>
              </Alert>
            </div>
          ) : (
            <Alert className="text-blue-700 border-blue-100 bg-blue-50/80">
              <AlertTitle className="flex items-center gap-2">
                <div className="w-4 h-4 border-2 border-blue-500 rounded-full border-t-transparent animate-spin" />
                <span>Verifying {branding.domain}...</span>
              </AlertTitle>
              <AlertDescription className="text-blue-600/75">
                Next check in {countdown} seconds. This generally takes 1-2 minutes.
              </AlertDescription>
            </Alert>
          )}
        </div>
      </CardContent>

      <CardFooter className="gap-2 text-sm text-muted-foreground">
        Need help?
        <Link
          to={r.support.root}
          className="font-medium transition-colors  text-primary hover:text-primary/80 hover:underline"
        >
          Contact our support team
        </Link>
      </CardFooter>
    </Card>
  )
}

export default ActiveDomainCard
